import { useEffect, useState, Suspense } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';

import 'react-toastify/dist/ReactToastify.css';
import './scss/otk-styles.scss';
import LoadPanel from 'devextreme-react/load-panel.js';
import { NavigationProvider } from 'contexts/navigation';
import { AuthProvider, useAuth } from 'contexts/auth';
import { useScreenSizeClass } from 'utils/media-query';
import { Content } from './Content';
import { UnauthenticatedContent } from './UnauthenticatedContent';

import uaMessages from 'contexts/ua.json';
import { appInfo } from './app-info';
import { MessageProvider } from 'contexts/messages/messages';
import { NotificationManager } from 'components';
import { News } from 'pages/news/news';
import { loadMessages, locale } from 'devextreme/localization';

import { Helmet, HelmetProvider } from 'react-helmet-async';
import { NODE_ENV } from 'app-constants';

const App = () => {
  loadMessages(uaMessages);
  locale('uk');

  const { user, loading, reAuth } = useAuth();
  const [ firstStart, setFirstStart ] = useState(false);

    useEffect(() => {
    document.title = appInfo.docTitle;
  }, []);
  useEffect(() => {
    const chkUser = async() => {
      if (!user) {
        const res = await reAuth();
        setFirstStart(!res.isOk);
      }
    };

    chkUser();

  }, [ reAuth, user ]);

  const cbHandler = () => {
    setFirstStart(false);
    return 0;
  };

  if (loading) return <LoadPanel visible={true} />;

  if (user) {
    if (firstStart) return <News onApprove={cbHandler} />;

    return (
      <HelmetProvider>
                        <Helmet>

          <link rel="icon" href={getFavicon()} />
          <link rel="apple-touch-icon" href={getFavicon()} />
          <title>{getTitle()}</title>
        </Helmet>
      <MessageProvider>
        <NotificationManager />
        <Suspense fallback={<LoadPanel/>}>

          <Content />
        </Suspense>
      </MessageProvider>
      </HelmetProvider>
    );
  }

  return <HelmetProvider>
                        <Helmet>

          <link rel="icon" href={getFavicon()} />
          <link rel="apple-touch-icon" href={getFavicon()} />
          <title>{getTitle()}</title>
        </Helmet>
        <UnauthenticatedContent />;
    </HelmetProvider>;
};

const AppMain = () => {
  const screenSizeClass = useScreenSizeClass();
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <AuthProvider>
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
};

  const getTitle = () => {
    switch (NODE_ENV) {
      case 'production':
      case 'sub':
      case 'sub2':
        return 'OTK Кабінет';
      case 'staging':
        return '[STAGING] Мій Додаток';
      case 'development':
      case 'dev':
        return '[DEV] OTK Кабінет';
      default:
        return 'Мій Додаток';
    }
  };

    const getFavicon = () => {
    switch (NODE_ENV) {
      case 'production':
      case 'sub':
      case 'sub2':
        return '/favicon.svg';
      case 'kab':
      case 'kab2':
        return '/favicon-atg.ico';

      default:
        return '/favicon.svg';
    }
  };

export default AppMain;
